export default __webpack_public_path__ + "27f4d360c73e5b1da5c707a10406729a.png";